module.exports = __webpack_public_path__ + "img/united_kingdom_round_icon_64.18126fee.png";